import { Table, Paper, TableHead, TableRow, TableCell, TableBody } from "@mui/material";
import { FC } from "react";
import { DecimalUtil } from "src/framework/commons/DecimalUtils";
import { Formater, TypeRecords } from "src/framework/commons/Formater";

interface FinanciamentoProps {
    dados: any;
}

const Financiamento: FC<FinanciamentoProps> = ({
    dados,
}) => {

    const simulacaoBv = dados.projeto?.simulacao_financiamento?.simulacoes.find((simulacao: any) => simulacao.financeira === "bv")

    function handleTextoSimulacao(dadosSimulacao: any) {
        if (dadosSimulacao?.cpfCnpj?.length > 11) {
            return `Essa simulação foi feita com os dados do CNPJ ${Formater.toString(dadosSimulacao?.cpfCnpj, TypeRecords.CPF_CNPJ)} - Data de criação da empresa: ${Formater.toString(dados.projeto.simulacao_financiamento?.dataNascimentoOuFundacao, TypeRecords.DATE)} com faturamento mensal de R$ ${DecimalUtil.decimal(dados.projeto.simulacao_financiamento?.rendaOuFaturamentoMensal, 2)}`;
        }
        return `Essa simulação foi feita com os dados do CPF ${Formater.toString(dadosSimulacao?.cpfCnpj, TypeRecords.CPF_CNPJ)} - Data de nascimento: ${Formater.toString(dados.projeto.simulacao_financiamento?.dataNascimentoOuFundacao, TypeRecords.DATE)} com renda mensal de R$ ${DecimalUtil.decimal(dados.projeto.simulacao_financiamento?.rendaOuFaturamentoMensal, 2)}`;
    }


    return <>
        <div className="title">Simulação de financiamento</div>

        <div className="default-text-list"><span>Os valores abaixo são apenas uma referência de parcela.</span></div>

        <div className="default-text-list"><span>{handleTextoSimulacao(dados.projeto.simulacao_financiamento)}</span></div>

        <div className="default-text-list" style={{marginTop: "26pt"}}><span>Valor financiado: {DecimalUtil.decimal(dados.projeto.simulacao_financiamento?.valorFinanciado)}</span></div>

        <div className="title" style={{marginTop: "26pt"}}>Opções de financiamento direto (via Plataforma)</div>

        <div style={{ display: "flex" }}>
            {/*
            <Table component={Paper} size="small" className="table" style={{ marginRight: "22pt" }}>
                <TableHead style={{ height: "80pt" }}>
                    <TableRow>
                        <TableCell className="tableColEquipamentoHead" style={{ textAlign: "center", height: "35pt", width: "40%" }}><img style={{ width: "130pt" }} src={dados?.imagens?.logoSantander} /></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow style={{ paddingBottom: "12pt", verticalAlign: "top" }}>
                        <TableCell className={(simulacaoSantander?.parcelas.length % 2 !== 0) ? "tableColEquipamentoOdd" : "tableColEquipamento"} style={{ padding: "0", paddingBottom: "12pt" }}>
                            {simulacaoSantander && (
                                simulacaoSantander?.parcelas.map((parcela: any, index: number) => {
                                    return (
                                        <div className={(index % 2 === 0) ? "defaultTextListTableFinanciamentoEven" : "defaultTextListTableFinanciamentoOdd"}>
                                            {DecimalUtil.decimal(parcela.parcela, 0)}x de R$ {DecimalUtil.decimal(parcela.valor, 2)}
                                        </div>
                                    )
                                })
                            )}
                            <div className="defaultTextListTableFinanciamento">O prazo de carência do contrato é de 90 dias a contar a partir da data de assinatura do cliente:</div>
                            <div className="container-financiamento">
                                <div className="item-financiamento">
                                    <div className="marcador-financiamento" >»</div>
                                    <div className="texto-financiamento">O valor da parcela poderá variar para mais
                                        ou para menos de acordo com taxas atualizadas do Santander;</div>
                                </div>
                                <div className="item-financiamento">
                                    <div className="marcador-financiamento" >»</div>
                                    <div className="texto-financiamento">As taxas podem variar de acordo com o
                                        perfil do contratante, como pela quantidade
                                        de parcelas do financiamento.</div>
                                </div>
                            </div>
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
            */}

            <Table component={Paper} size="small" className="table coluna-financiamento">
                <TableHead style={{ height: "80pt" }}>
                    <TableRow>
                        <TableCell className="tableColEquipamentoHead bg-verde-intelbras" style={{ textAlign: "center", height: "35pt", width: "40%" }}><img style={{ width: "50pt" }} src={dados?.imagens?.logoBV} alt="Imagem logo da BV" /></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow style={{ paddingBottom: "12pt", verticalAlign: "top" }}>
                        <TableCell className={(simulacaoBv?.parcelas.length % 2 !== 0) ? "tableColEquipamentoOdd" : "tableColEquipamento"} style={{ padding: "0", paddingBottom: "12pt" }}>
                            {simulacaoBv && (
                                simulacaoBv?.parcelas.map((parcela: any, index: number) => {
                                    return (
                                        <div className={(index % 2 === 0) ? "defaultTextListTableFinanciamentoEven" : "defaultTextListTableFinanciamentoOdd"}>
                                            {DecimalUtil.decimal(parcela.parcela, 0)}x de R$ {DecimalUtil.decimal(parcela.valor, 2)}
                                        </div>
                                    )
                                })
                            )}
                            <div className="defaultTextListTableFinanciamento">O prazo de carência do contrato é de 90 dias a contar a partir da data de assinatura do cliente:</div>
                            <div className="container-financiamento">
                                <div className="item-financiamento">
                                    <div className="marcador-financiamento" >»</div>
                                    <div className="texto-financiamento">O valor da parcela poderá variar para mais ou para menos de acordo com taxas atualizadas do BV;</div>
                                </div>
                                <div className="item-financiamento">
                                    <div className="marcador-financiamento" >»</div>
                                    <div className="texto-financiamento">As taxas podem variar de acordo com o perfil do contratante, como pela quantidade de parcelas do financiamento.</div>
                                </div>
                            </div>
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </div>
    </>
}

export default Financiamento;